<template>
  <div class="row full_page page_container">
    <div class="column content-box">
      <woot-tabs :index="selectedTabIndex" @change="onClickTabChange">
        <woot-tabs-item
          v-for="tab in tabs"
          :key="tab.key"
          :name="tab.name"
          :show-badge="false"
        />
      </woot-tabs>
      <woot-button
        color-scheme="success"
        class-names="button--fixed-right-top"
        icon="add-circle"
        @click="openTopUpModal"
      >
        {{ $t('TOP_UP.BUTTON_TITLE') }}
      </woot-button>
      <div class="columns">
        <stripe-component
          :modal-value="this.topUpModal"
          @close-modal="closeModal"
        ></stripe-component>
        <paid-messaging v-if="selectedTabIndex == 0" :key="selectedTabIndex"></paid-messaging>
        <bots-transactions v-if="selectedTabIndex == 1" :key="selectedTabIndex"></bots-transactions>
        <!-- <OrderUsages v-if="selectedTabIndex == 2" ></OrderUsages> -->
        <order-usages v-if="selectedTabIndex == 2" :key="selectedTabIndex"></order-usages>
        <CallUsages v-if="selectedTabIndex == 3" :key="selectedTabIndex"></CallUsages>
        <MeetingUsages v-if="selectedTabIndex == 4" :key="selectedTabIndex"></MeetingUsages>
        <expired-credit v-if="selectedTabIndex == 5" :key="selectedTabIndex"></expired-credit>
        <TransactionSummary v-if="selectedTabIndex == 6" :key="selectedTabIndex"></TransactionSummary>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import PaidMessaging from './PaidMessaging';
// import QuotaMessaging from './QuotaMessaging';
import StripeComponent from 'dashboard/components/stripe/StripeComponent';
import stripeMixin from '../../../../../../shared/mixins/stripeMixin';
import BotsTransactions from './BotsTransactions';
import OrderUsages from './OrderUsages'
import ExpiredCredit from './ExpiredCredit.vue'
import MeetingUsages from './MeetingUsages.vue'
import TransactionSummary from './TransactionSummary.vue'
import CallUsages from './CallUsages.vue'

export default {
  components: {
    PaidMessaging,
    StripeComponent,
    BotsTransactions,
    OrderUsages,
    ExpiredCredit,
    MeetingUsages,
    TransactionSummary,
    CallUsages,
  },
  mixins: [alertMixin, stripeMixin],
  data() {
    return {
      selectedTabIndex: 0,
      topUpModal: false,
    };
  },
  computed: {
    ...mapGetters({
      isFetching: 'getIsFetchingUsageReport',
      currentUserId: 'getCurrentUserID',
      currentUser: 'getCurrentUser',
    }),
    tabs() {
      return [
        {
          key: 0,
          name: this.$t('BILLING_USAGES.TAB_PAID_MESSAGING'),
        },
        {
          key: 1,
          name: this.$t('BILLING_USAGES.TAB_BOT_TRANSACTIONS'),
        },
        {
          key: 2,
          name: this.$t('BILLING_USAGES.TAB_USAGES_OF_ORDER'),
          // name: 'Usages of Order',
        },
        {
          key: 3,
          name: this.$t('BILLING_USAGES.TAB_CALL'),
        },
        {
          key: 4,
          name: this.$t('BILLING_USAGES.TAB_MEETING'),
        },
        {
          key: 5,
          name: this.$t('BILLING_USAGES.TAB_EXPIRED_CREDIT'),
        },
        {
          key: 6,
          name: this.$t('BILLING_USAGES.TAB_TRANSACTION_SUMMARY'),
        },
        // {
        //   key: 1,
        //   name: this.$t('BILLING_USAGES.TAB_QUOTA_MESSAGING'),
        // },
      ];
    },
  },
  mounted() {
    this.checkStripeSuccess();
  },
  methods: {
    onClickTabChange(index) {
      this.selectedTabIndex = index;
    },
    openTopUpModal() {
      this.topUpModal = !this.topUpModal;
    },
    closeModal() {
      this.topUpModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-box {
  overflow: unset;
}
.table-wrap {
  padding-left: var(--space-small);
}

.woot-table {
  width: 100%;
  margin-top: var(--space-small);
}

.no-items-error-message {
  margin-top: var(--space-larger);
}

.tabs {
  padding-left: 0;
  margin-right: var(--space-medium);
  user-select: none;
}

.item {
  padding-left: 0;
  max-width: 10rem;
  min-width: 8rem;
}

.item-description {
  padding-left: 0;
  max-width: 16rem;
  min-width: 10rem;
}

.key {
  font-family: monospace;
}

::v-deep {
  .tabs-title a {
    font-weight: var(--font-weight-medium);
    padding-top: 0;
  }
}
</style>
